import { render, staticRenderFns } from "./ExternalApiConfig.vue?vue&type=template&id=28daf708"
import script from "./ExternalApiConfig.vue?vue&type=script&lang=js"
export * from "./ExternalApiConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports